import autosize from 'autosize';

export default {
    bind: function() {
        setTimeout(function() {
            autosize(this.el);
        }.bind(this), 10);
    }
}



// WEBPACK FOOTER //
// ./app/statamic/resources/js/directives/elastic.js